import React from 'react';
import { Layout } from 'antd';

const { Footer: AntFooter } = Layout;

export default function Footer() {
    return (
        <AntFooter style={{ textAlign: 'center', color: '#8c8c8c', background: 'transparent' }}>
            HIS ©{new Date().getFullYear()} Powered by KUANTUM BULUT BİLİŞİM VE YAZILIM A.Ş.
        </AntFooter>
    );
}
